import { Vehiculo } from "../../../../../infraestructure/persistence/rest/VehiculosAdapter"

export const createOptions = (data:any) =>{
  return data.map((t: Vehiculo)=> { return { label: t.vehiculo, value: t.vehiculo } })
}